import { render, staticRenderFns } from "./FormsEdit.vue?vue&type=template&id=1b5bcd88&"
import script from "./FormsEdit.vue?vue&type=script&lang=js&"
export * from "./FormsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports